import React from "react";
import { useAuth0 } from "../auth";

const ProfileMenu = () => {
    const { loading, user, logout } = useAuth0();

    if (loading || !user) {
        return <div>Loading...</div>;
    }

    return (
        <div className="profile-picture-container">
            <div>
                <img src={user.picture} alt="Profile" className="profile-picture"/>
                <p>{user.name}</p>
            </div>
            <div onClick={() => logout({ returnTo: window.location.origin })} style={ {cursor: 'pointer'} }>Log out</div>
        </div>
    );
};

export default ProfileMenu;